// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"244c73b7","488":"1fe83087","711":"1db8fadf","881":"7ef289cc","944":"f65d4403","960":"c4c0b250","992":"17fa9c05"}[chunkId] + ".chunk.js";
};